import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface LayoutStyles {
  layout: Styles
  layoutPaywall: Styles
  mainLayout: Styles
}

export const useStyles = createUseStyles<LayoutStyles>((theme) => ({
  layout: () => ({
    backgroundColor: theme.colors.merlinPageBackground,
  }),
  mainLayout: {
    maxWidth: theme.calcUnit(1312),
    margin: '0 auto',
    paddinTop: theme.calcUnit(theme.spacing.s6),
    paddingInline: theme.calcUnit(theme.spacing.s1),
    paddingBottom: theme.calcUnit(theme.spacing.s9),
    overflowX: 'hidden',
  },
  layoutPaywall: {
    overflow: 'hidden',
  },
}))
